<div class="hidden-input-file">
  <input type="file" #fileInput (change)="upload()" ng2FileSelect multiple [uploader]="uploader"/>
</div>

<div *ngIf="attaches.length">
  <div class="card-row">
    <ng-container *ngFor="let doc of attaches">
      <div class="card-col">
        <div class="attach">
          <div class="size">{{ formatBytes(doc.size) }}</div>

          <div class="attach-block" nbTooltip="{{doc.header}}" (click)="download(doc)">
            <div class="attach-item">
              <img *ngIf="!doc.icon" src="/assets/images/crm/file_attachment_icon.svg" alt="{{doc.header}}">
              <img *ngIf="doc.icon" src="/assets/images/dam/vivid/{{doc.icon}}.svg" alt="{{doc.header}}">
              {{ doc.header }}
            </div>
          </div>
          <div class="attach-action-bar">
            <div class="attach-action-block">
              <nb-icon class="attach-action" nbTooltip="Удалить" icon="trash-outline" (click)="deleteAttach(doc)"></nb-icon>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
